"use client";
import { createContext, type PropsWithChildren, useState } from "react";

export type SignatureContextState = {
  signature: string;
  setSignature: (signature: string) => void;
  clearSignature: () => void;
};

export const SignatureContext = createContext<SignatureContextState>({
  signature: "",
  setSignature: () => {},
  clearSignature: () => {},
});

export const SignatureContextProvider = ({ children }: PropsWithChildren) => {
  const [signature, setSignature] = useState("");

  return (
    <SignatureContext.Provider value={{ signature, setSignature, clearSignature: () => setSignature("") }}>
      {children}
    </SignatureContext.Provider>
  );
};
